import { render, staticRenderFns } from "./sitemetadata.vue?vue&type=template&id=36136f89&scoped=true"
import script from "./sitemetadata.vue?vue&type=script&lang=js"
export * from "./sitemetadata.vue?vue&type=script&lang=js"
import style0 from "./sitemetadata.vue?vue&type=style&index=0&id=36136f89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36136f89",
  null
  
)

export default component.exports